import React from "react";
import { Container } from "react-bootstrap";
import ServicesOptions from "../components/Services/ServicesOptions";

const Services = () => {
  return (
    <Container fluid>
      <ServicesOptions />
    </Container>
  );
};

export default Services;
